import { Injectable } from '@angular/core';
import { City } from '../interfaces/city';
import { CityService } from 'src/app/modules/administration/city/city.service';
import { CatalogService } from './catalog.service';

/**
 * La reteica de la ciudad de origen depende de la empresa de transporte. Cuando
 * cambia la empresa en un formulario de creación (manual o solicitud de servicio)
 * se recalcula con este servicio en vez de obligar a elegir la ciudad de nuevo.
 */
@Injectable({ providedIn: 'root' })
export class OriginReteicaService {

  constructor(private catalogService: CatalogService, private cityService: CityService) { }

  /**
   * Reteica de la ciudad para la empresa de transporte (incluye la heredada de la
   * ciudad principal). 0 si no tiene; null si la ciudad no aparece o la consulta
   * falla. El llamador no debe conservar la reteica de la empresa anterior en ese
   * caso: la trata como sin reteica.
   */
  async resolve(municipalityCode: string, transportCompanyId?: string): Promise<number | null> {
    if (!municipalityCode) { return null; }
    try {
      const cities = await this.catalogService.getCityByMunicipalityCode(municipalityCode, 1, 1, transportCompanyId).toPromise() as City[];
      const list = cities || [];
      const city = list.find(item => item && item.id === municipalityCode) || list[0];
      return city ? this.cityService.getReteicaCity(city) : null;
    } catch (error) {
      return null;
    }
  }
}
